import {
  type Country as CssModulesCountry,
  countryData as cssModulesCountryData,
  PhoneField as CssModulesPhoneField,
  type PhoneFieldInterface as CssModulesPhoneFieldInterface,
  type PhoneFieldProps as CssModulesPhoneFieldProps,
} from '@sunwebgroup/uds-ui/fields/phone-field'
import { ForwardRefExoticComponent, RefAttributes } from 'react'
import { styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/phone-field' instead.
 */
type Country = CssModulesCountry

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/phone-field' instead.
 */
type PhoneFieldInterface = CssModulesPhoneFieldInterface

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/phone-field' instead.
 */
type PhoneFieldProps = CssModulesPhoneFieldProps

/**
 * @deprecated This const alias is deprecated, kept only for backward compatibility. Please use it from '@sunwebgroup/uds-ui/fields/phone-field' instead.
 */
const countryData = cssModulesCountryData

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/phone-field' instead.
 */
export const PhoneField: ForwardRefExoticComponent<PhoneFieldProps & RefAttributes<HTMLInputElement>> = Object.assign(
  styled(CssModulesPhoneField)<PhoneFieldProps>``,
  { displayName: 'PhoneField' },
)

export { type Country, countryData, type PhoneFieldInterface, type PhoneFieldProps }
